var fetchCsv = function (postCodeFront) {
    return fetch("https://ken-all.numb86.net/csv/" + postCodeFront + ".csv", { mode: 'cors' });
};
export default fetchCsv;
//# sourceMappingURL=fetchCsv.js.map